export type PaginationQuery = {
    OrderByProperty: string;
    OrderByDirection: string;
    PageNumber: number;
    PageSize: number;
}

export function PaginationQueryDefaultValues():PaginationQuery
{
    return{
        OrderByProperty: '',
        OrderByDirection: '',
        PageNumber: 0,
        PageSize: 25
    }
}
